module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/section07_03_american-village-b002daebd63d5922f238c1c93f85a9fd.jpg";